import { render, staticRenderFns } from "./ManualCall.vue?vue&type=template&id=6d0bad64&scoped=true&"
import script from "./ManualCall.vue?vue&type=script&lang=js&"
export * from "./ManualCall.vue?vue&type=script&lang=js&"
import style0 from "./ManualCall.vue?vue&type=style&index=0&id=6d0bad64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0bad64",
  null
  
)

export default component.exports